<ng-container *transloco="let t">
<ng-template #gatherLeadSource>

  <form class="form w-100" #leadSourceForm="ngForm" novalidate id="leadSourceForm" name="leadSourceForm">
    @if (inEditMode) {
      <div class="fv-row row">
        <div class="col-sm-4 col-form-label fw-bold fs-6 editor-label">Require an Answer</div>
        <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
          <input class="form-check-input h-20px w-30px" type="checkbox" name="answerRequired"
            id="answerRequired" [(ngModel)]="step.fieldConfig[fields.ANSWER].isRequired" />
          <label class="form-check-label" for="answerRequired">
            {{isAnswerRequired() ? t('common.yes') : t('common.no')}}
          </label>
        </div>
      </div>

      <div class="fv-row row">
        <div class="col-sm-4 col-form-label fw-bold fs-6 editor-label">Pick Agent Referral from a List</div>
        <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
          <input class="form-check-input h-20px w-30px" type="checkbox" name="pickReferralFromAList"
            id="pickReferralFromAList" [(ngModel)]="step.pickAgentReferralFromAList" />
          <label class="form-check-label" for="pickReferralFromAList">
            {{step.pickAgentReferralFromAList ? t('common.yes') : t('common.no')}}
          </label>
        </div>
        @if (step.pickAgentReferralFromAList) {
          <div class="col-sm-4 form-check form-switch form-check-custom form-check-solid">
            <input class="form-check-input h-20px w-30px" type="checkbox" name="agentFromListRequired"
              id="agentFromListRequired" [(ngModel)]="step.fieldConfig[fields.AGENT_FROM_LIST].isRequired" />
            <label class="form-check-label" for="agentFromListRequired">Selection Required</label>
          </div>
        }
      </div>

      @if (availableLeadSourceOptions.length) {
        <div class="fv-row">
          <div class="col-sm-3 col-form-label fw-bold fs-6 editor-label">Pick Options</div>
          @for (availableOption of availableLeadSourceOptions; track availableOption.name) {
            <div class="checkbox mb-3 d-flex align-items-center">
              <label class="form-check form-check-inline form-check-solid me-2"
                for="availableOption_{{availableOption.name}}">
                <input id="availableOption_{{availableOption.name}}" name="availableOption_{{availableOption.name}}"
                  type="checkbox" (change)="optionsSelectedToPresentToUserChanged(availableOption, $event)"
                  [checked]="valuesOfOptionsSelectedToBePresentedToUserAsChoices.includes(availableOption.name.toLowerCase())"
                  class="form-check-input">
                <span class="fw-bold ps-2 fs-5">{{availableOption.text}}</span>
              </label>
              @if (hasFollowUpSetting(availableOption)) {
                <div class="form-check form-switch form-check-custom form-check-solid ms-auto">
                  <input class="form-check-input h-20px w-30px" type="checkbox"
                    name="followUpRequired_{{availableOption.name}}" id="followUpRequired_{{availableOption.name}}"
                    [(ngModel)]="step.fieldConfig[availableOption._defaultsKey].isRequired" />
                  <label class="form-check-label" for="followUpRequired_{{availableOption.name}}">Follow-up Required</label>
                </div>
              }
            </div>
          }
        </div>
      }
    }

    <div class="row mb-4">
      <div class="col-md-12 fv-row">
        <label class="form-label mb-2" [class.required]="isAnswerRequired()">{{ t('wizard.leadSource.howDidYouHear') }}</label>
        <select #leadCameFrom="ngModel" class="form-select form-select-solid"
          [ngClass]="{'is-invalid' : leadCameFrom && leadCameFrom.touched && leadCameFrom.invalid}"
          [required]="isAnswerRequired()"
          [(ngModel)]="leadSourceType"
          (change)="onLeadSourceChangedType()"
          name="howDidYouHearAboutUs">
          <option [ngValue]="null">{{ t('common.selectOne') }}</option>
          @for (leadSourceOption of step.leadSourceOptions; track leadSourceOption.value) {
            <option value="{{leadSourceOption.value}}">{{ leadSourceOptionLabel(leadSourceOption) }}</option>
          }
        </select>
        <div class="invalid-feedback">{{ t('wizard.leadSource.pleaseSelectHowYouHeard') }}</div>
      </div>
    </div>
    @if ((leadSourceType === 'Agents' || leadSourceType === 'Real Estate Agent') && step.pickAgentReferralFromAList && !useManualAgentEntry) {
      <div class="row mb-4">
        <div class="col-md-12 fv-row">
          <label class="form-label mb-2" [class.required]="isAgentFromListRequired()">{{ t('wizard.leadSource.whoWasTheAgent') }}</label>
          <p-select
            #leadSourceAgentValue="ngModel"
            [(ngModel)]="leadSourceAgent"
            [required]="isAgentFromListRequired()"
            [ngClass]="{'is-invalid' : leadSourceAgentValue.touched && leadSourceAgentValue.invalid}"
            (ngModelChange)="onAgentChanged()"
            [options]="referralAgentGroups"
            optionLabel="name"
            optionValue="id"
            optionGroupLabel="label"
            optionGroupChildren="items"
            [group]="true"
            styleClass="form-select-solid"
            id="lead-source-agent"
            name="leadSourceAgent"
            [placeholder]="t('wizard.leadSource.selectAnAgent')"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
          >
            <ng-template let-group pTemplate="group">
              {{ group.label }}
            </ng-template>

            <ng-template let-item pTemplate="item">
              {{ item.name }}
            </ng-template>
          </p-select>
          <div class="invalid-feedback">{{ t('wizard.leadSource.pleaseSelectAgent') }}</div>
        </div>
      </div>
    }
    @if (shouldShowAgentTypeSelector()) {
      <div class="row mb-4">
        <div class="col-md-12 fv-row">
          <label class="form-label mb-2 required">{{ t('wizard.leadSource.whatTypeOfAgent') }}</label>
          <p-select
            #agentTypeValue="ngModel"
            [(ngModel)]="agentTypeId"
            (ngModelChange)="onAgentTypeChanged()"
            [options]="agentTypes"
            optionLabel="agentTypeName"
            optionValue="agentTypeId"
            styleClass="form-select-solid"
            id="lead-source-agent-type"
            name="leadSourceAgentType"
            required
            [ngClass]="{'is-invalid' : agentTypeValue.touched && agentTypeValue.invalid}"
            [placeholder]="t('wizard.leadSource.selectAnAgentType')"
            [filter]="true"
            appendTo="body"
          >
          </p-select>
          <div class="invalid-feedback">{{ t('wizard.leadSource.pleaseSelectAgentType') }}</div>
        </div>
      </div>
    }
    @if (shouldShowReferralTextInput()) {
      <div class="row mb-4">
        <div class="col-md-12 fv-row">
          <label class="form-label mb-2" [class.required]="isReferralTextRequired()">{{referralSourceLabel}}</label>
          <!-- A browser input cap, not a keydown guard: it covers pastes and drops too, and
               does not have to swallow Tab and the arrow keys to do it.
               [attr.maxlength] and NOT [maxlength] - the latter matches Angular's
               MaxLengthValidator ([maxlength][ngModel]), which would mark a stored value
               longer than the cap invalid. validate() blocks Next on form validity, so that
               would strand a borrower on this step over data they did not type. -->
          <input class="form-control form-control-lg form-control-solid" type="text" name="leadSource" [required]="isReferralTextRequired()"
            [ngClass]="{'is-invalid' : leadSourceValue && leadSourceValue.touched && leadSourceValue.invalid}" autocomplete="off"
            [(ngModel)]="leadSource" #leadSourceValue="ngModel"
            [attr.maxlength]="maxReferralSourceLength"/>
          <div class="invalid-feedback">{{ t('wizard.leadSource.pleaseSelectHowYouHeard') }}</div>
          <span class="text-muted" style="font-style: italic;"> {{ t('wizard.leadSource.charactersLeft', { count: noOfCharactersLeft }) }}</span>
        </div>
      </div>
    }
  </form>
</ng-template>

<wizard-step-template [stepMainTemplate]="gatherLeadSource" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
